<template>
  <!-- 剧集抽屉 -->
  <a-drawer title="其他信息" width="700" :visible="visible" :closable="false" :footer="null" @close="onClose">
    <div v-if="detail.id">
      <a-row>
        <a-col :span="4">Facebook：</a-col>
        <a-col>{{ fid || '-' }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="4">Google：</a-col>
        <a-col>{{ gid || '-' }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="4">Apple：</a-col>
        <a-col>{{ aid || '-' }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="4">邮箱：</a-col>
        <a-col>{{ email || '-' }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="4">设备ID：</a-col>
        <a-col>{{ detail.device_id || '-' }}</a-col>
      </a-row>
    </div>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose } from 'vue'
import { Platforms, PayChannels } from '@/utils/constantList'
// import { payUserInfo } from '@/api/reseller'

// 抽屉展示状态
let visible = ref(false)
// 数据
let detail = ref({})
let times = ref(null)

//邮箱
let email = ref(null)
//apple_id
let aid = ref(null)
//face_id
let fid = ref(null)
//google_id
let gid = ref(null)
// 打开抽屉
function showDrawer(record) {
  // 展开
  console.log(record.email);

  visible.value = true
  // 数据
  detail.value = record
  fid.value = record.facebook_id
  gid.value = record.google_id
  aid.value = record.apple_id
  email.value = record.email


  // 获取详情
  getDetail()
}

// 关闭抽屉
function onClose() {
  times.value = 0
  detail.value = {}
  visible.value = false
}

// 获取详情
function getDetail() {
  //   payUserInfo({ uid: detail.value.user_id, source: detail.value.source }).then((res) => {
  //     const { code, data } = res
  //     if (code === 0) {
  //       times.value = data.times
  //     }
  //   }).catch(err => {
  //   })
}

// 暴露出去
defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.ant-row {
  height: 40px;

  .ant-col {
    text-align: right;

    &:first-child {
      margin-right: 6px;
    }
  }
}
</style>